import * as React from "react"

export const preventContextMenu = (event: MouseEvent | React.MouseEvent): void => {
  event.preventDefault()
}

export const usePreventContextMenu = (): void => {
  React.useEffect(() => {
    document.addEventListener("contextmenu", preventContextMenu)
    return () => {
      document.removeEventListener("contextmenu", preventContextMenu)
    }
  }, [])
}
